let primaryColorCode = localStorage.getItem('primaryColor');

const colors = {
  gray000: '#fafafa',
  gray100: '#e5e5e5',
  gray200: '#cccccc',
  gray300: '#b2b2b2',
  gray400: '#999999',
  gray500: '#7f7f7f',
  gray600: '#666666',
  gray700: '#4c4c4c',
  gray800: '#323232',
  gray900: '#191919',
  blue000: '#e5e5ff',
  blue100: '#ccccff',
  blue200: '#9999ff',
  blue300: '#6666ff',
  blue400: '#3232ff',
  blue500: '#0000ff',
  blue600: '#0000cc',
  blue700: '#000099',
  blue800: '#000066',
  blue900: '#000033',
  green000: '#e5ffe5',
  green100: '#ccffcc',
  green200: '#99ff99',
  green300: '#66ff66',
  green400: '#32ff32',
  green500: '#00ff00',
  green600: '#00cc00',
  green700: '#009900',
  green800: '#006600',
  green900: '#003300',
  aqillizBlue: '#007bff',
  red000: '#ffe5e5',
  red100: '#ffcccc',
  red200: '#ff9999',
  red300: '#ff6666',
  red400: '#ff3232',
  red500: '#ff0000',
  red600: '#cc0000',
  red700: '#990000',
  red800: '#660000',
  red900: '#330000',
  yellow000: '#ffffe5',
  yellow100: '#ffffcc',
  yellow200: '#ffff99',
  yellow300: '#ffff66',
  yellow400: '#ffff32',
  yellow500: '#ffff00',
  yellow600: '#cccc00',
  yellow700: '#999900',
  yellow800: '#666600',
  yellow900: '#333300',
  white: '#ffffff',
  black: '#290808',
  darkblack: '#000000',
  // Wireframe Colors
  navyBlue: '#23183f',
  royalBlue: '#4C6FD5',
  santasGray: '#9594A9',
  primaryGray: '#797979',
  disabledGray: '#E7E7E7',
  shadowGray: '#CCCCCC',
  errorRed: '#FF4733',
  indianRed: '#CD5858',
  silver: '#BABABA',
  violet: '#746791',
  darkViolet: '#321E5C',
  backgroundWhite: '#FAFAFA',
  smokyWhite: '#F2F2F2',
  translucentWhite: '#FFFFFF8C',
  corvetteOrange: '#FFC376',
  darkOrange: '#FFA558',
  transparent: 'transparent',

  //Fimp Colors
  aqillizRed: '#FF5349',
  aqillizDarkGrey: '#2F2C2C',
  aqillizGrey: '#565F63',
  sidebarIconGrey: '#A5A3A3',
  selectOrange: '#FFC376',
  charcoalGrey: '#434343',
  disabledTextGrey: '#909090',
  greyBg: '#EAE6E4',
  checkedGreen: '#76FFD5',
  noiseStandardRed: '#FF827B',
  noiseHighBlue: '#CF8EFF',
  noiseLowGreen: '#76FFD5',
  reuploadBrown: '#B13530',

  // revamp color
  newGray: '#3E4F4D',
  newWhite: '#FFF',
  newBorder: '#EAEAEA',
  newFont: '#606060',
  newTableBorder: '#DDE1EF',
  newRed: '#F0554E',
  infoRed: '#FE6174',
  newyellow: '#FFFDE3',
  lightGraynew: '#F7F8F8',
  primaryColorCode: primaryColorCode,
};

export const withOpacity = (color: string, opacity: number) =>
  color +
  Number(opacity * 255)
    .toString(16)
    .split('.')[0];

export default colors;
